import { render, staticRenderFns } from "./caseMenu.vue?vue&type=template&id=2e0e9d40&scoped=true"
import script from "./caseMenu.vue?vue&type=script&lang=js"
export * from "./caseMenu.vue?vue&type=script&lang=js"
import style0 from "./caseMenu.vue?vue&type=style&index=0&id=2e0e9d40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0e9d40",
  null
  
)

export default component.exports